// tour.actions.ts
import { createAction, props } from '@ngrx/store';

export const startTour = createAction(
  '[Tour] Start Tour',
  props<{ route?: string }>()
);

export const completeTour = createAction(
  '[Tour] Complete Tour'
);

export const cancelTour = createAction(
  '[Tour] Cancel Tour'
);

export const resetTourStatus = createAction(
  '[Tour] Reset Tour Status'
);

export const setTourActive = createAction(
  '[Tour] Set Tour Active',
  props<{ active: boolean }>()
);

export const advanceStep = createAction(
  '[Tour] Advance Step',
  props<{ stepIndex: number }>()
);

export const setCurrentRoute = createAction(
  '[Tour] Set Current Route',
  props<{ route: string }>()
);

export const resumeTour = createAction(
  '[Tour] Resume Tour',
  props<{ route: string, stepIndex: number }>()
);
